import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'youtubeCaptions',
})
export class YoutubeCaptionsPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    private translate: TranslateService
  ) {}

  /**
   * Add query parameters to embed url, to turn on captions for slovenian language.
   * @param url YouTube embed url
   */
  transform(url: string): SafeResourceUrl {
    const currentLanguageObj = environment.locations.find(
      (obj) => obj.lang.code === this.translate.currentLang
    );
    if (currentLanguageObj.lang.videoSubtitles) {
      const prefix = url.indexOf('?') > -1 ? '&' : '?';
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `${url}${prefix}cc_load_policy=1&hl=${currentLanguageObj.lang.code}`
      );
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
